import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IMaskInput } from 'react-imask';
import { fromJS } from 'immutable';

import Loading from './shared/Loading';
import Support from './shared/Support';
import Footer from './shared/Footer';
import Term from './shared/Term';
import { updateParent, setHeight } from '../lib/modal';
import { getLocalItem } from '../lib/local_storage';
import useBootstrapper from '../hooks/useBootstrapper';

import logo from '../images/ck-nav-logo-2022.svg';

const terms = [1, 3, 6, 12];

export default function ProductDisplayPage({ match }) {
  const dispatch = useDispatch();
  const merchant = useSelector(state => state.entities.get('merchant').last());
  const approvedTerms = useSelector(state => state.entities.get('approved_term'));
  const [loading, setLoading] = useState(true);
  const publicKey = match.params.public_key;

  const chargesFromStr = match.params.charges.split(',');

  const chargesObj = {
    data: {
      total: parseInt(chargesFromStr[0]).toString(),
      shipping: parseInt(chargesFromStr[1]).toString(),
      tax: parseInt(chargesFromStr[2]).toString(),
      discount_amount: 0,
      grand_total: parseInt(chargesFromStr[4]).toString()
    }
  }

  const [charges, setCharges] = useState(chargesObj);

  useBootstrapper(publicKey, charges);

  useEffect(() => {
    const content = document.getElementById('content');

    if (!loading) {
      setHeight(content.clientHeight + 50);
    }
  }, [loading]);

  useEffect(() => {
    if (merchant) {
      setLoading(false);
    }
  }, [merchant, charges]);

  const onChange = value => {
    chargesObj.data.grand_total = value;
    setCharges(chargesObj);
  }

  const dismiss = () => {
    return updateParent('cancel', null);
  }

  if (!publicKey && !charges) {
    return (<div id="content">
      <Support />
    </div>);
  }

  if (loading) return (<Loading active={true} />);

  return (
    <div id="content">
      <nav className="header box is-shadowless level is-mobile">
        <div className="level-left">
          <div className="level-item">
            <a className="is-size-5" onClick={dismiss}><FontAwesomeIcon icon={['fal', 'times']} /></a>
          </div>
        </div>

        <div className="level-item">
          <img src={logo} />
        </div>

        <div className="level-right">
          <div className="level-item">
          {merchant && <a id="learn-more" className="is-size-5" href={merchant.learn_more_link} target="_new"><FontAwesomeIcon icon={['fal', 'question-circle']} /></a>}
          </div>
        </div>
      </nav>

      <div id="main-content" className="container">

        <div className="has-text-centered">
          <div className="is-size-5 has-text-weight-bold" style={{ lineHeight: '2rem' }}>Easy business payments for up to 12 months</div>
          <div className="has-text-grey">Checking your eligibilty won't affect your credit</div>

          <div className="my-3 has-text-weight-semibold form-inline">
            <label htmlFor="amount" className="has-text-grey-dark">Sample payments for </label>
            <IMaskInput
              className="price"
              id="amount"
              name="amount"
              size="8"
              mask="$num"
              unmask={true}
              blocks={{
                num: {
                  mask: Number,
                  scale: 0
                }
              }}
              onComplete={onChange}
              value={charges.data.grand_total}
            />
          </div>
        </div>

        {approvedTerms.count() > 0 && approvedTerms
          .filter(i => i.available && terms.includes(i.term))
          .valueSeq()
          .map((d, idx) => (<Term
            key={idx}
            index={idx}
            merchant={merchant}
            term={d}
          />))}

        {match.params.type !== 'cart' && <Link
          to="/prequal"
          className={classNames('button is-primary is-large is-fullwidth has-text-weight-bold mt-5', {
            'is-loading': loading
          })}>
          See if you qualify
        </Link>}
      </div>

      <Footer />
    </div>
  );
}
